import courses from './courses';
/**
 * Инициализация роутера
 */
export default function router() {
    async function route() {
        const [courseId, lectureId] = (location.hash || '').slice(1).split('/').filter(Boolean);
        await courses.selectCourse(courseId);
        await courses.selectLecture(lectureId);
    }
    window.addEventListener('hashchange', route);
    route();
}
